<template>
  <section class="flsa-report-preview-metadata">
    <div class="flsa-report-preview-metadata-header mb-2">
      <JobProfileStatus
        v-if="profileSource === 'draft'"
        :is-hris-profile="false"
      />
      <JobProfileStatus
        v-else-if="profile?.status"
        :is-hris-profile="true"
        :status="profile.status"
      />
    </div>

    <h1 class="text-h1 text-textDarkest mb-2">
      {{ profile?.title || '' }}
    </h1>

    <dl class="flsa-report-preview-metadata-grid mb-0">
      <template
        v-for="row in metadataRows"
        :key="row.label"
      >
        <dt class="text-h3 text-textDark">
          {{ row.label }}:
        </dt>
        <dd class="text-body-2 text-textLight mb-0">
          {{ row.value || '' }}
        </dd>
      </template>
    </dl>
  </section>
</template>

<script setup>
import { computed } from 'vue';
import JobProfileStatus from '@/components/jobProfiles/editor/JobProfileStatus.vue';

const props = defineProps({
  profile: {
    type: Object,
    default: () => ({}),
  },
  profileSource: {
    type: String,
    default: 'hris',
    validator: (value) => ['hris', 'draft'].includes(value),
  },
});

const metadataRows = computed(() => {
  const profile = props.profile || {};

  const jobCode = props.profileSource === 'draft'
    ? profile.job_code
    : profile.hris_job_code;

  return [
    { label: 'Job Code', value: jobCode },
    { label: 'Job Level', value: profile.job_level },
    { label: 'Location', value: profile.location },
  ].filter((row) => Boolean(row.value));
});
</script>

<style scoped lang="less">
.flsa-report-preview-metadata-header {
  :deep(.job-status) {
    width: fit-content;
  }
}

.flsa-report-preview-metadata-grid {
  display: grid;
  grid-template-columns: 110px 1fr;
  gap: 10px;
  align-items: center;
}
</style>
